<template>
  <el-dialog
    class="preview-dialog"
    :visible.sync="batchVisible"
    fullscreen
    :before-close="clearBatchInfo"
    center
  >
    <div class="dialog-container" v-loading="loading">
      <div class="flex card-container">
        <div class="card-container-left">
          <div class="card-container-top">
            <div class="flex dialog-label-top">
              <div>抽检任务：</div>
              <el-tooltip
                class="item"
                effect="dark"
                :content="taskInfo.name"
                placement="top-start"
              >
                <div class="dialog-label-text">{{ taskInfo.name }}</div>
              </el-tooltip>
            </div>
            <div class="flex dialog-label-pro" style="align-items: center">
              <div>抽检进度：</div>
              <div>{{ rate + " " + "/" + " " + taskInfo.number }}</div>
            </div>
          </div>

          <div class="card-tag flex">
            <div class="card-tag-text">
              <span>关联技能点：</span>
              <span>{{ taskInfo.stack.stack_name.name }}</span>
            </div>
            <div class="card-tag-text" v-if="questionInfo.last_check_result">
              <span>上次抽检结果：</span>
              <el-tooltip
                class="item"
                effect="dark"
                :content="questionInfo.info"
                placement="top-start"
              >
                <span
                  :class="[
                    'card-tag-info',
                    (questionInfo.last_check_result.data || {}).status == '2'
                      ? 'adopt'
                      : 'fail'
                  ]"
                  >{{ questionInfo.info }}</span
                >
              </el-tooltip>
            </div>
            <div class="card-tag-time">
              <span class="dialog-label">建议最长答题时间：</span>
              <span class="dialog-value">{{ questionInfo.time_max }} 秒</span>
            </div>
          </div>
          <div class="dialog-content">
            <div class="dialog-flex">
              <div class="dialog-label">题干：</div>
              <markdown-it
                v-if="questionInfo.translator"
                class="dialog-value"
                :md="(questionInfo.translator['zh-cn'] || {}).stem"
              ></markdown-it>
            </div>
            <div
              class="dialog-flex"
              v-for="(option, optionIndex) in questionInfo.options"
              :key="optionIndex"
            >
              <div class="dialog-label">
                <div>选项 {{ optionIndex + 1 }}：</div>
                <div class="jk-green" v-if="option.correct">（正确答案）</div>
              </div>
              <markdown-it
                class="dialog-value"
                v-if="option.translator['zh-cn']"
                :md="option.translator['zh-cn'].option"
              ></markdown-it>
              <div class="dialog-value" v-else>-</div>
            </div>
            <div class="dialog-flex">
              <div class="dialog-label">解析：</div>
              <markdown-it
                class="dialog-value"
                v-if="questionInfo.translator['zh-cn']"
                :md="questionInfo.translator['zh-cn'].analysis"
              ></markdown-it>
              <div class="dialog-value" v-else>-</div>
            </div>
            <div class="dialog-flex mb-20">
              <div class="dialog-label">所属知识点：</div>
              <div class="dialog-value">
                <template>
                  <el-tag
                    class="mr-12 mb-4"
                    size="medium"
                    v-for="point in questionInfo.knowledge_points"
                    :key="point.knowledge_point_id"
                  >
                    {{ point.knowledge_point_name }}
                  </el-tag>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="card-container-right">
          <div class="f_18 right-title mb-8">抽检环节</div>
          <div class="basic-section pro-section mt-4">
            <div class="adopt-box">
              <div class="flex adopt-box-top">
                <div class="jk-page-h4" style="color: rgba(56, 158, 13, 1)">
                  抽检通过
                </div>
                <div style="font-size: 14px; color: #bfbfbf">
                  请给这道题目打个分～
                </div>
              </div>
              <div
                class="flex"
                style="align-items: center; justify-content: space-between"
              >
                <div class="score-title">
                  评分：
                </div>
                <el-radio-group
                  class="radio-group-hard"
                  size="mini"
                  v-model="targetData.score"
                  :disabled="editing"
                  @change="
                    (targetData.fail_reason = []), (targetData.comment = null)
                  "
                >
                  <el-radio-button
                    size="mini"
                    :label="level"
                    v-for="level in 10"
                    :key="level"
                  ></el-radio-button>
                </el-radio-group>
              </div>
            </div>
            <div class="flex">
              <div class="card-line-d"></div>
              <div class="card-line"></div>
            </div>
            <div class="mb-20 adopt-box-bottom">
              <div style="margin-bottom: 20px">
                <div class="jk-page-h4" style="color: rgba(217, 54, 62, 1)">
                  抽检不通过
                </div>
              </div>
              <el-checkbox-group
                class="check-box"
                v-model="targetData.fail_reason"
                @change="targetData.score = null"
                :disabled="editing"
              >
                <div class="flex-ju">
                  <el-checkbox label="1">题目错别字</el-checkbox>
                  <el-checkbox label="2">题目无意义</el-checkbox>
                </div>
                <div class="flex-ju">
                  <el-checkbox label="3">题目错误</el-checkbox>
                  <el-checkbox label="0">其他</el-checkbox>
                </div>
                <div class="flex-ju">
                  <el-checkbox label="4">知识点/题目老旧</el-checkbox>
                  <el-checkbox label="6">含厂商信息</el-checkbox>
                </div>
                <div class="flex-ju">
                  <el-checkbox label="5">与企业实际工作无关</el-checkbox>
                </div>
                <el-input
                  v-if="targetData.fail_reason.includes('0')"
                  placeholder="请输入其他原因"
                  v-model="targetData.comment"
                  :disabled="editing"
                  size="mini"
                ></el-input>
              </el-checkbox-group>
            </div>
            <div class="flex">
              <div class="card-line-d"></div>
              <div class="card-line" style="margin-top: 0"></div>
            </div>
          </div>
          <div class="foot-btn">
            <el-button
              v-if="!editing"
              class="fixed-btn-top"
              size="medium"
              type="primary"
              @click="handleSubmit"
              >抽检结果提交
            </el-button>
            <el-button
              v-else
              class="fixed-btn"
              size="medium"
              @click="getVerifyQuestion"
              >下一题</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import skillService from "@/global/service/skill";
import MarkdownIt from "@jiker/markdown-it/MarkdownIt.vue";
export default {
  components: {
    MarkdownIt
  },
  props: {
    batchVisible: {
      default: false,
      type: Boolean
    },
    taskInfo: {
      type: Object
    }
  },
  created() {
    this.getVerifyQuestion();
  },
  data() {
    return {
      loading: false,
      discardVisible: false,
      btnLoading: false,
      questionInfo: {
        options: [],
        translator: {},
        last_check_result: []
      },
      targetData: {
        fail_reason: [],
        score: null,
        comment: null
      },
      page: 1,
      editing: false,
      rate: 0,
      fail_list: [
        "其他",
        "题目错别字",
        "题目无意义",
        "题目错误",
        "知识点/题目老旧",
        "与企业实际工作无关",
        "含厂商信息"
      ]
    };
  },
  computed: {
    ...mapState(["authPermissions"])
  },
  methods: {
    clearBatchInfo() {
      this.page = 1;
      this.$emit("clearBatchInfo");
      this.$emit("update:batchVisible", false);
    },
    handleSubmit() {
      if (!(this.targetData.fail_reason.length || this.targetData.score)) {
        this.$message.error("请选对题目进行抽检结论");
        return;
      }

      if (
        this.targetData.fail_reason.includes("0") &&
        !this.targetData.comment
      ) {
        this.$message.error("请输入其他原因");
        return;
      }
      const params = this.targetData;
      params.status = this.targetData.score ? 2 : 3;
      skillService
        .skillSpotCheck(this.questionInfo.id, this.taskInfo.id, params)
        .then(() => {
          this.$message.success("抽检结果已提交");
          this.btnLoading = false;
          this.editing = true;
          this.rate++;
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    getVerifyQuestion() {
      this.loading = true;
      const params = {
        page: 1,
        page_size: 1
      };
      skillService
        .skillSpotCheckQuestion(this.taskInfo.id, params)
        .then(res => {
          this.rate = this.taskInfo.number - res.pagination.total;
          if (!res.list.length) {
            this.loading = false;
            this.$message.info("该条件下暂无待抽检题目");
            return;
          }
          this.targetData = {
            fail_reason: [],
            score: null
          };
          this.questionInfo = res.list[0];
          let info = "";
          if (this.questionInfo.last_check_result) {
            if (this.questionInfo.last_check_result.data.status == 2) {
              info =
                "通过 (" +
                this.questionInfo.last_check_result.data.score +
                ") 分";
              this.$set(this.questionInfo, "info", info);
            } else {
              const failInfo = this.questionInfo.last_check_result.data.fail_reason.map(
                data => {
                  if (data == 0) {
                    return (
                      this.fail_list[data] +
                      ":" +
                      this.questionInfo.last_check_result.data.comment
                    );
                  } else {
                    return this.fail_list[data];
                  }
                }
              );
              info = "不通过原因 (" + String(failInfo) + ")";
              this.$set(this.questionInfo, "info", info);
            }
          }

          this.loading = false;
          this.editing = false;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="less" scoped>
.adopt-box {
  padding: 10px 25px 0px 16px;
  .adopt-box-top {
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    width: 100%;
  }
}
.adopt-box-bottom {
  padding: 0px 25px 0px 16px;
  /deep/.el-checkbox__label {
    color: #606266;
    font-size: 14px;
    font-weight: 400;
  }
}
.score-title {
  font-size: 14px;
  width: 60px;
  font-weight: 500;
}
.dialog-label-top {
  color: rgba(0, 0, 0, 0.85);
  font-size: 16px;
  font-weight: 500;
  .dialog-label-text {
    width: 240px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.dialog-label-pro {
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  font-weight: 500;
}
.right-title {
  width: 100%;
  padding: 10px 40px 12px 16px;
  border-bottom: 1px solid rgba(245, 245, 245, 1);
}
.card-line-d {
  width: 4%;
}
.card-line {
  width: 96%;
  height: 1px;
  background-color: rgba(240, 240, 240, 1);
  margin: 20px 0;
}
.flex-ju {
  width: 96%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.check-box {
  padding-left: 14px;
  /deep/.el-checkbox__label {
    width: 70px;
  }
}
.radio-group-hard {
  /deep/.el-radio-button--mini .el-radio-button__inner {
    padding: 5px 8px;
    font-size: 12px;
  }
}
.f_16 {
  font-size: 16px;
  font-weight: 500;
  color: rgba(0, 0, 0, 65%);
}
.f_18 {
  font-size: 18px;
  font-weight: 500;
  color: rgba(0, 0, 0, 75%);
}
.flex {
  display: flex;
  .flex-none {
    flex: none;
    padding-top: 24px;
    width: 85px;
  }
  .flex-1 {
    flex: 1;
  }
}
.card-tag-info {
  cursor: pointer;
  width: 170px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  &.fail {
    color: rgb(217, 54, 62);
  }
  &.adopt {
    color: rgb(56, 158, 13);
  }
}
.preview-dialog {
  // height: 100vh;
  /deep/.el-dialog__header {
    padding: 0;
    .el-dialog__headerbtn {
      .el-dialog__close.el-icon-close {
        font-size: 18px;
        font-weight: 600;
        color: #303133;
      }
    }
  }
  /deep/.el-dialog__body {
    padding: 0;
  }
}
.dialog-container {
  .card-container {
    display: flex;
  }
  .card-container-left {
    flex: 1;
    border-right: 1px solid #dcdfe6;
    padding: 16px 0 10px;
    height: 100vh;
    overflow-y: auto;
    .status {
      float: right;
      align-items: center;
    }
    .card-container-top {
      padding: 0 20px 10px;
      box-shadow: inset 0px -1px 0px 0px #d9d9d9;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .dialog-label {
        font-weight: 500;
      }
    }
    .card-top {
      padding: 0 20px 10px;
      align-items: center;
      .card-title {
        font-size: 18px;
        font-weight: 500;
      }
      i[class*="el-icon-"] {
        font-size: 18px;
        font-weight: 600;
      }
    }
    .card-tag {
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      background: rgba(23, 100, 232, 0.04);
      height: 48px;
      padding: 0px 20px;
      color: rgba(0, 0, 0, 65%);
      .dialog-label {
        font-weight: 500;
      }
      .card-tag-text {
        display: flex;
        align-items: center;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        font-size: 14px;
      }
      .card-tag-time {
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        font-size: 14px;
      }
    }
  }
  .card-container-right {
    // padding: 10px 40px 10px 16px;
    width: 350px;
    .float {
      float: right;
    }
    .basic-section {
      // margin-top: 11%;
      // padding: 10px 0;
      &.pro-section {
        border-bottom: none;
        // padding: 10px 0 0;
      }
      .radio-group {
        /deep/.el-radio-button__inner {
          padding: 5px 8px;
        }
      }
    }
    .flex {
      align-items: center;
      &.column {
        flex-direction: column;
        align-items: flex-start;
        .column-item {
          position: relative;
          padding-left: 20px;
          display: flex;
          &::before {
            position: absolute;
            content: "";
            top: 8px;
            left: 10px;
            display: inline-block;
            width: 4px;
            height: 4px;
            border-radius: 50%;
            background: rgba(0, 0, 0, 65%);
          }
        }
        .column-item_second {
          position: relative;
          padding-left: 40px;
          &::before {
            position: absolute;
            content: "";
            top: 8px;
            left: 25px;
            // transform: translateY(-50%);
            display: inline-block;
            width: 4px;
            height: 4px;
            border-radius: 50%;
            border: 1px solid rgba(0, 0, 0, 65%);
            // background: rgba(0, 0, 0, 65%);
          }
        }
      }
    }
    .card-top {
      height: 28px;
      margin-right: 10px;
      .count-record {
        cursor: pointer;
        color: #409eff;
      }
    }
    .card-title {
      font-size: 18px;
      font-weight: 500;
      color: rgba(0, 0, 0, 65%);
    }
    .card-button {
      width: 100%;
      justify-content: flex-end;
    }
  }
  .dialog-content {
    margin: 0 auto;
    width: 700px;
    position: relative;
    .el-icon-copy-document {
      position: absolute;
      top: 0px;
      right: -80px;
      font-size: 18px;
      cursor: pointer;
    }
    .dialog-flex {
      display: flex;
      margin: 12px 0;
      .dialog-label {
        flex: none;
        width: 100px;
        text-align: right;
      }
      .dialog-value {
        flex: 1;
        &.jiker-markdown-it {
          padding: 0;
        }
        &.dialog-operation {
          display: flex;
          justify-content: space-between;
        }
      }
    }
  }
}
.btn-box {
  margin-top: 8px;
  display: flex;
  justify-content: center;
}
.dialog-container-tips {
  margin-top: 8px;
  color: #e6a23c;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .tips-item {
    position: relative;
    padding-left: 20px;
    text-align: left;
    &::before {
      position: absolute;
      content: "";
      top: 50%;
      left: 10px;
      transform: translateY(-50%);
      display: inline-block;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background: #e6a23c;
    }
  }
}
.foot-btn {
  width: 100%;
  display: flex;
  justify-content: center;
}
.fixed-btn-top {
  background: rgba(64, 158, 255, 1);
}
.fixed-btn {
  width: 100px;
}
/deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: rgba(82, 196, 26, 1);
  border-color: rgba(82, 196, 26, 1);
  box-shadow: -1px 0 0 0 rgba(82, 196, 26, 1);
}
</style>
